<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/D5yzAG/tc-custom/9781468303063.jpg?1699128254214" alt="This image is the cover for the book Marathon"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Marathon
      </h1>
      <p class="bookDescription body article font2">
        <p> <b>This lively ancient history demonstrates how the Athenian victory against Persian invaders was critical to the development of Western society.</b><br/><br/> The Battle of Marathon in 490 B.C. is widely considered the most decisive event in the struggle between the Greeks and the Persians. In <i>Marathon</i>, historian Richard Billows goes further, arguing that it was also the most significant moment in our collective history.<br/><br/> As 10,000 Athenian citizens faced a Persian military force of more than 25,000, Greek victory appeared impossible. But the men of Athens were tenacious and the Persians were defeated. Following the battle, the Athenian hoplite army ran 26.5 miles from Marathon to Athens to defend their port from the Persian navy. Greek freedom ensued and the achievements of the culture became much of the basis for Western civilization.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Richard A. Billows
      </h2>
      
      <p class="authorDescription body article">Richard A. Billows is a professor at Columbia University specializing in Ancient Greek and Roman epigraphy. He is the author of Marathon: How One Battle Changed Western Civilization, as well as Antigonos the One-Eyed and the Creation of the Hellenistic State, Kings and Colonists: Aspects of Macedonian Imperialism, and Julius Caesar: The Colossus of Rome. He lives in New York City.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The Overlook Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9df75270